/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { ReactComponent as SvgViewDocuments } from "components/widgets/training/view-documents.svg";
import { connect } from "react-redux";
import CountDown from "react-countdown";
import ChildTraining from "components/widgets/training/RegisteredTraining";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import { showModal } from "actions";
import TrainingDetailModal from "components/widgets/training/TrainingDetailModal";
import { Trans } from "react-i18next";
import { SCORMURL, LANGUAGE_CODES, LANGUAGES, ENV_NAME } from "util/constant";
import "components/widgets/training/Training.css";
import TrainingDetailDocuments from "./TrainingDetailDocuments";
import i18n from "i18next";
import Helpers from "util/helpers";
import { Dropdown } from "react-bootstrap";

import { ReactComponent as UKFlag } from "components/widgets/language/flag-united-kingdom.svg";
import { ReactComponent as UAEFlag } from "components/widgets/language/flag-united-arab-emirates.svg";
import { ReactComponent as FRFlag } from "components/widgets/language/flag-france.svg";
import { ReactComponent as DEFlag } from "components/widgets/language/flag-germany.svg";
import { ReactComponent as RUFlag } from "components/widgets/language/flag-russia.svg";
import { ReactComponent as ESFlag } from "components/widgets/language/flag-spain.svg";
import { ReactComponent as TRFlag } from "components/widgets/language/flag-turkey.svg";
import { ReactComponent as HRFlag } from "components/widgets/language/flag-croatian.svg";

class RegisteredTraining extends Component {
  rowClassName = "";

  state = {
    showingChildren: true,
    selectedTrainingLanguage: null,
  };

  constructor(props) {
    super(props);
    this.trainingNameRef1 = React.createRef();
    this.trainingNameRef2 = React.createRef();
  }

  toggleChildren = () => {
    let showingChildren = this.state.showingChildren;
    this.setState({ showingChildren: !showingChildren });
  };

  showDetail = (t, parentId) => {
    //ELearning ise açılmasın
    if (t.trainingMethod.value === 1) return;

    this.props.showModal({
      modalType: "trainingDetail",
      modalTitle: "",
      modalContent: (
        <TrainingDetailModal
          training={t}
          trainingType="registered"
          isParent={t.isParent}
          parentId={parentId}
        />
      ),
      modalFooter: null,
      modalCustomClassName: "modal-xl ttModal",
    });
  };

  showDocumentsModal = (t) => {
    // Eğitim Dökümanları = 10517
    this.props.showModal({
      modalType: "trainingDetail",
      modalTitle: i18n.t("10517"),
      modalContent: <TrainingDetailDocuments trainingId={t.training.id} />,
      modalFooter: null,
      modalCustomClassName: "modal-xl ttModal",
    });
  };

  renderDate = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleDateString(localStorage.getItem("i18nextLng"));
  };

  renderTime = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleTimeString(localStorage.getItem("i18nextLng"));
  };

  renderDateTime = (type, dateString) => {
    //1 = ELearning
    if (type !== 1)
      return (
        <>
          {this.renderDate(dateString)}
          <br />
          {this.renderTime(dateString)}
        </>
      );
    else return this.renderDate(dateString);
  };

  renderSuccessStatus = (status) => {
    switch (status) {
      case "NotStarted":
        return (
          <td>
            <div className="durumBaslamadi">
              <Trans desc="Başlamadı">10386</Trans>
            </div>
          </td>
        );

      case "Live":
        return (
          <td>
            <div className="durumCanli">
              <Trans desc="Canlı">10387</Trans>
            </div>
          </td>
        );
      case "Continue":
        return (
          <td>
            <div className="durumDevam">
              <Trans desc="Canlı">10390</Trans>
            </div>
          </td>
        );
      default:
        return <td></td>;
    }
  };

  renderTrainingMethodIcon = (value, isParent) => {
    if (isParent) {
      let icon = "iconmford fo-icon-add";
      if (!this.state.showingChildren) icon = "iconmford fo-icon-remove";
      return (
        <td
          onClick={() => this.toggleChildren()}
          className="showGrup openCloseBtn"
          style={{
            textAlign: "left",
            color: "rgb(45, 150, 205)",
            paddingLeft: "25px",
            fontSize: "20px",
          }}
        >
          <span className={icon}></span>
        </td>
      );
    } else {
      switch (value) {
        case 1:
          return (
            <td onClick={() => this.toggleChildren()}>
              <span className="iconmford fo-icon-live-tv"></span>
            </td>
          );
        case 3:
          return (
            <td onClick={() => this.toggleChildren()} className="showGrup">
              <span className="iconmford fo-icon-tv ">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
              </span>
            </td>
          );
        default:
          return (
            <td onClick={() => this.toggleChildren()}>
              <span className="iconmford fo-icon-class "></span>
            </td>
          );
      }
    }
  };

  renderDocumentIcon = (t) => {
    if (!t.hasDocument) return null;

    return (
      <SvgViewDocuments
        onClick={() => this.showDocumentsModal(t)}
        className="training-table__icon-viewdoc"
      />
    );
  };

  renderContinueAction = (training) => {
    if (training.isParent) return null;

    if (
      training.trainingMethod.value === 3 &&
      training.timeplans !== null &&
      training.timeplans.length > 0
    ) {
      const fiveMin = 5 * 60 * 1000; // 5dk kalmis ise sayac gorunmesin
      const startDate = new Date(training.timeplans[0].startDate);
      const diff = startDate - new Date() - fiveMin;
      if (diff > 0) {
        return (
          <td>
            <div className="countdown">
              <CountDown date={Date.now() + diff} />
            </div>
          </td>
        );
      }
    }

    let url = "";
    let langCode = this.state.selectedTrainingLanguage
      ? this.state.selectedTrainingLanguage.value
      : Helpers.getLangCode(localStorage.getItem("i18nextLng"));
    switch (training.buttonType) {
      case "Play":
       // url = `${SCORMURL}/index?employeeCode=${this.props.employeeCode}&registeredTrainingId=${training.registeredTrainingId}&langCode=${langCode}&env=${ENV_NAME}`;
       
       const postUrl = `${SCORMURL}/index?env=${ENV_NAME}`;

        const payload = {
          employeeCode: this.props.employeeCode,
          registeredTrainingId: training.registeredTrainingId,
          langCode: langCode,
        };

        url = (
          <span
            className="iconmford fo-icon-play-circle-outline"
            style={{ cursor: "pointer" }}
            onClick={() => {
              const newWindow = window.open(postUrl, "_blank");

              // alıcı hazırım deyince gönder
              const readyListener = (e) => {
                if (e.data === "SCORM_READY") {
                  newWindow.postMessage(payload, SCORMURL);
                  window.removeEventListener("message", readyListener);
                }
              };

              window.addEventListener("message", readyListener);
            }}
          />
        );
       
       
        break;
      case "Redirect":
        url = training.fullURL;
        break;
      default:
        url = "";
        break;
    }

    if (training.buttonType === "Play") {
      return (
        <td>

 {/*
          <a href={url} target="_blank" rel="noopener noreferrer">
          <span className="iconmford fo-icon-play-circle-outline"></span>
          </a>
*/}
           {url}

        </td>
      );
    } else if (training.buttonType === "Redirect") {
      return (
        <td>
          <a
            className="btn-redirect"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Trans desc="Yönlendir">10543</Trans>
          </a>
        </td>
      );
    }
  };

  renderStatusChart = (status) => {
    if (status === 0) {
      return (
        <div className="single-chart">
          <svg viewBox="-2 -2 40 40" className="circular-chart orange">
            <path
              className="circle-bg"
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <text x="18" y="22.35" className="percentage">
              {status}
            </text>
          </svg>
        </div>
      );
    } else if (status < 100) {
      return (
        <div className="single-chart">
          <svg viewBox="-2 -2 40 40" className="circular-chart orange">
            <path
              className="circle-bg"
              d="M18 2.0845          a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <path
              className="circle"
              strokeDasharray={`${status}, 100`}
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <text x="18" y="22.35" className="percentage">
              {status}
            </text>
          </svg>
        </div>
      );
    } else {
      return (
        <div className="single-chart">
          <svg viewBox="-2 -2 40 40" className="circular-chart green">
            <path
              className="circle-bg"
              d="M18 2.0845
        a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <path
              className="circle"
              strokeDasharray={`${status}, 100`}
              d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <text x="18" y="22.35" className="percentage">
              {status}
            </text>
          </svg>
        </div>
      );
    }
  };

  renderTrainingName = (t) => {
    let lang = localStorage.getItem("i18nextLng");
    let trainingName = "";

    if (lang === LANGUAGES.Turkish) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.Turkish
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else if (lang === LANGUAGES.English) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.English
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else if (lang === LANGUAGES.Arabic) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.Arabic
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else if (lang === LANGUAGES.French) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.French
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else if (lang === LANGUAGES.German) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.German
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else if (lang === LANGUAGES.Russian) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.Russian
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else if (lang === LANGUAGES.Spanish) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.Spanish
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else if (lang === LANGUAGES.Croatian) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.Croatian
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else if (lang === LANGUAGES.Italian) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.Italian
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else {
      trainingName = t.training.name;
    }

    return (
      <>
        {t.isRoleTraining && <i className="role-egitim mr-1"></i>}
        {t.isTargetTraining && <i className="hedeflenen-egitim mr-1"></i>}
        {trainingName}
      </>
    );
  };

  renderLanguageVersions = (t) => {
    if (t.languageVersions === null || t.languageVersions.length === 0) {
      return (
        <Dropdown>
          <Dropdown.Toggle size="sm" variant="">
            <React.Fragment>
              <UKFlag className="img-fluid flag" /> EN
            </React.Fragment>
          </Dropdown.Toggle>
        </Dropdown>
      );
    }

    return (
      <Dropdown>
        <Dropdown.Toggle size="sm" variant="">
          {this.state.selectedTrainingLanguage && (
            <React.Fragment>
              {this.getFlag(this.state.selectedTrainingLanguage.value)}{" "}
              {this.state.selectedTrainingLanguage.label}
            </React.Fragment>
          )}
          {!this.state.selectedTrainingLanguage && (
            <React.Fragment>
              <UKFlag className="img-fluid flag" /> EN
            </React.Fragment>
          )}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {t.languageVersions.map((item) => (
            <Dropdown.Item
              key={t.key + item.languageVersionId}
              eventKey={item.languageCode.value}
              onSelect={(key, obj) => {
                if (this.trainingNameRef1.current)
                  this.trainingNameRef1.current.innerHTML = item.trainingName;
                if (this.trainingNameRef2.current)
                  this.trainingNameRef2.current.innerHTML = item.trainingName;

                this.setState({
                  selectedTrainingLanguage: item.languageCode,
                });
              }}
            >
              {this.getFlag(item.languageCode.value)} {item.languageCode.label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  getFlag = (languageCode) => {
    switch (languageCode) {
      case LANGUAGE_CODES.English:
        return <UKFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.Arabic:
        return <UAEFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.French:
        return <FRFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.German:
        return <DEFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.Russian:
        return <RUFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.Spanish:
        return <ESFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.Turkish:
        return <TRFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.Croatian:
        return <HRFlag className="img-fluid flag" />;
      default:
        return null;
    }
  };

  renderChildren = (t) => {
    if (t.isParent && this.state.showingChildren === false) {
      let childTrainings = t.childTrainings.map((ct) => {
        return (
          <React.Fragment key={ct.key}>
            <DesktopBreakpoint>
              <ChildTraining
                key={ct.key}
                t={ct}
                isChild={true}
                parentId={t.training.id}
              />
            </DesktopBreakpoint>
            <TabletBreakpoint>
              <ChildTraining
                key={ct.key}
                t={ct}
                isChild={true}
                parentId={t.training.id}
              />
            </TabletBreakpoint>
          </React.Fragment>
        );
      });
      return (
        <>
          <DesktopBreakpoint>
            <tr>
              <td colSpan="10">
                <table width="100%">
                  <tbody>
                    <tr className="child">
                      <td className="child">
                        <table className="table">
                          <tbody>{childTrainings}</tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </DesktopBreakpoint>
          <TabletBreakpoint>
            <tr>
              <td colSpan="2" className="accordionArea">
                <div className="accordion" id="accordionDays">
                  {childTrainings}
                </div>
              </td>
            </tr>
          </TabletBreakpoint>
        </>
      );
    }
  };

  renderTabletModeDetail = (t) => {
    if (!this.state.showingChildren) {
      return (
        <tr className="child">
          <td className="child" colSpan="2">
            <table>
              <tbody>
                <tr>
                  <td></td>
                  <td>{this.renderLanguageVersions(t)}</td>
                </tr>
                <tr>
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Yer">10016</Trans>
                    </div>
                  </td>
                  <td>{t.trainingLocation ?? ""}</td>
                </tr>
                <tr>
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Süre">10017</Trans>
                    </div>
                  </td>
                  <td>
                    {t.timeplans !== null && t.timeplans.length > 0
                      ? `${t.timeplans[0].duration}`
                      : null}
                    <sup>
                      <Trans desc="GÜN">10388</Trans>
                    </sup>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Durum">10018</Trans>
                    </div>
                  </td>
                  <td>
                    <div id="durumChart_1" data-percent="34">
                      <div>{this.renderStatusChart(t.score)}</div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Başarı">10019</Trans>
                    </div>
                  </td>
                  {this.renderSuccessStatus(t.successStatus)}
                </tr>
                <tr>
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Başlangıç">10020</Trans>
                    </div>
                  </td>
                  <td>
                    {t.timeplans !== null && t.timeplans.length > 0
                      ? this.renderDateTime(
                        t.trainingMethod.value,
                        t.timeplans[0].startDate
                      )
                      : null}
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Bitiş">10021</Trans>
                    </div>
                  </td>
                  <td>
                    {t.timeplans !== null && t.timeplans.length > 0
                      ? this.renderDateTime(
                        t.trainingMethod.value,
                        t.timeplans[0].endDate
                      )
                      : null}
                  </td>
                </tr>
                <tr data-dt-row="9" data-dt-column="7">
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Dokumanlar">10178</Trans>
                    </div>
                  </td>
                  <td className="u-centered">{this.renderDocumentIcon(t)}</td>
                </tr>
                <tr>
                  <td>
                    <div className="tableTitle"></div>
                  </td>
                  {this.renderContinueAction(t)}
                </tr>
                {this.renderChildren(t)}
              </tbody>
            </table>
          </td>
        </tr>
      );
    } else return null;
  };

  render() {
    const { t, isChild } = this.props;

    return (
      <>
        <DesktopBreakpoint>
          <tr className="grupEgitim" key={t.key}>
            {this.renderTrainingMethodIcon(t.trainingMethod.value, t.isParent)}
            <td
              className="showGrup"
              onClick={() => this.showDetail(t, this.props.parentId)}
              ref={this.trainingNameRef1}
            >
              {this.renderTrainingName(t)}
            </td>
            <td>{this.renderLanguageVersions(t)}</td>
            <td className="showGrup">{t.trainingLocation ?? ""}</td>
            <td className="showGrup">
              {t.timeplans !== null && t.timeplans.length > 0
                ? `${t.timeplans[0].duration}`
                : null}
              <sup>
                <Trans desc="GÜN">10388</Trans>
              </sup>
            </td>
            <td className="showGrup">
              <div id="durumChart_1" data-percent="34">
                {this.renderStatusChart(t.score)}
              </div>
            </td>
            {this.renderSuccessStatus(t.successStatus)}
            <td className="showGrup">
              {t.timeplans !== null && t.timeplans.length > 0
                ? this.renderDateTime(
                  t.trainingMethod.value,
                  t.timeplans[0].startDate
                )
                : null}
            </td>
            <td className="showGrup">
              {t.timeplans !== null && t.timeplans.length > 0
                ? this.renderDateTime(
                  t.trainingMethod.value,
                  t.timeplans[0].endDate
                )
                : null}
            </td>
            <td className="showGrup">{this.renderDocumentIcon(t)}</td>
            {this.renderContinueAction(t)}
            <td></td>
          </tr>
          {this.renderChildren(t)}
        </DesktopBreakpoint>
        <TabletBreakpoint>
          {isChild ? (
            <div key={t.key} className="card" style={{ marginBottom: "0" }}>
              <div className="card-header">
                <a
                  className="btn btn-link"
                  type="button"
                  onClick={this.toggleChildren}
                >
                  <h2 className="mb-0">{t.training.name}</h2>
                </a>
              </div>
            </div>
          ) : (
            <tr key={t.key} className={this.rowClassName}>
              {this.renderTrainingMethodIcon(
                t.trainingMethod.value,
                t.isParent
              )}
              <td
                onClick={() => this.showDetail(t, this.props.parentId)}
                className="showGrup"
                ref={this.trainingNameRef2}
              >
                {this.renderTrainingName(t)}
              </td>
            </tr>
          )}
          {this.renderTabletModeDetail(t)}
        </TabletBreakpoint>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
  };
};

export default connect(mapStateToProps, { showModal })(RegisteredTraining);
